import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton, Grid } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import NorthomtonExamplesRows from "../model";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import NorthomtonScore from "../create";
import { useTranslate } from "src/locales";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
//MUZUN;445882;17022025
const northomtonColumns: GridColDef[] = [
    {
        field: "update",
        headerName: "Güncelle",
        width: 150,
        renderCell(params) {
            return (
                <Link to={`edit/${params.row.id}`}>
                    <EditIcon color="info" />
                </Link>
            );
        },
    },
    { field: "date", headerName: "Tarih", flex: 1 },
    { field: "field1", headerName: "Alan 1", flex: 1 },
    { field: "field2", headerName: "Alan 2", flex: 1 },
    { field: "field3", headerName: "Alan 3", flex: 1 },
    { field: "field4", headerName: "Alan 4", flex: 1 },
    { field: "field5", headerName: "Alan 5", flex: 1 },
    {
        field: "delete",
        headerName: "Sil",
        flex: 1,
        renderCell: (params) => (
            <IconButton onClick={() => console.log(params.row.id)}>
                <DeleteIcon color="error" />
            </IconButton>
        ),
    },
];

function NorthomtonScoreList() {
    const { t } = useTranslate();
    
    return (
        <BaseMedCardList
            rows={NorthomtonExamplesRows}
            columns={northomtonColumns}
            CreateComponent={NorthomtonScore}
            title="Northomton Skor"
        >
            <ByzMuiTypography
                sx={{
                    fontSize: 13,
                    fontWeight: 400,
                    whiteSpace: "nowrap",
                    wordWrap: "break-word",
                    margin: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Grid container spacing={1} style={{ width: "100%" }}>
                    <Grid
                        item
                        xs={3}
                        sx={{
                            padding: "10px",
                            color: "black",
                        }}
                    >
                        <ByzMuiTypography>{t("northomton-score.low-risk-skin-recommended")}</ByzMuiTypography>
                        <ByzMuiTypography>{t("northomton-score.moderate-risk-skin-recommended")}</ByzMuiTypography>
                        <ByzMuiTypography>{t("northomton-score.high-risk-skin-recommended")}</ByzMuiTypography>
                        <ByzMuiTypography>{t("northomton-score.extremely-high-risk-recommended")}</ByzMuiTypography>
                    </Grid>
                </Grid>
            </ByzMuiTypography>
        </BaseMedCardList>
    );
}

export default NorthomtonScoreList;
